import { Component } from '@angular/core';

@Component({
  selector: 'app-information-sidebar-feedback-peer',
  templateUrl: './information-sidebar-feedback-peer.component.html',
  styleUrls: ['./information-sidebar-feedback-peer.component.scss']
})
export class InformationSidebarFeedbackPeerComponent {
}
